import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-592c8481"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "base-title-button" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas fw-light" }, "add_circle", -1))
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-auto" }
const _hoisted_5 = { class: "row mt-3" }
const _hoisted_6 = { class: "col-12" }
const _hoisted_7 = { class: "table table-hover table-v2" }
const _hoisted_8 = { style: {"width":"23%"} }
const _hoisted_9 = { style: {"width":"23%"} }
const _hoisted_10 = { style: {"width":"23%"} }
const _hoisted_11 = { style: {"width":"23%"} }
const _hoisted_12 = { style: {"width":"8%"} }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = {
  colspan: "4",
  class: "text-muted"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseTitle = _resolveComponent("BaseTitle")!
  const _component_input_select = _resolveComponent("input-select")!
  const _component_MailingMailTemplateOverviewItem = _resolveComponent("MailingMailTemplateOverviewItem")!
  const _component_GenericFormWrapper = _resolveComponent("GenericFormWrapper")!
  const _component_base_container = _resolveComponent("base-container")!
  const _component_MailingMailTemplateDetail = _resolveComponent("MailingMailTemplateDetail")!
  const _component_BaseOffcanvas = _resolveComponent("BaseOffcanvas")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_base_container, { "has-build-status-on-page": "" }, {
      default: _withCtx(() => [
        _createVNode(_component_BaseTitle, {
          title: _ctx.$t('mailingTemplates'),
          mb: 4,
          "show-refresh-button": "",
          onRefresh: _ctx.reloadContent
        }, {
          buttons: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openNew && _ctx.openNew(...args))),
                class: "btn btn-hover icon-link"
              }, [
                _hoisted_2,
                _createTextVNode(" " + _toDisplayString(_ctx.$t('add')), 1)
              ])
            ])
          ]),
          _: 1
        }, 8, ["title", "onRefresh"]),
        _createVNode(_component_GenericFormWrapper, {
          pageUI: _ctx.pageUI,
          submitData: _ctx.doNothing,
          hideButtons: true
        }, {
          content: _withCtx(({ errors }) => [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_input_select, {
                  modelValue: _ctx.module,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.module) = $event)),
                  label: _ctx.$t('module'),
                  name: _ctx.$t('module'),
                  options: _ctx.allModules,
                  rules: "required",
                  errors: errors,
                  onChange: _ctx.reloadContent
                }, null, 8, ["modelValue", "label", "name", "options", "errors", "onChange"])
              ])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("table", _hoisted_7, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", _hoisted_8, _toDisplayString(_ctx.$t('name')), 1),
                      _createElementVNode("th", _hoisted_9, _toDisplayString(_ctx.$t('subject')), 1),
                      _createElementVNode("th", _hoisted_10, _toDisplayString(_ctx.$t('season')), 1),
                      _createElementVNode("th", _hoisted_11, _toDisplayString(_ctx.$t('labels')), 1),
                      _createElementVNode("th", _hoisted_12, _toDisplayString(_ctx.$t('actions')), 1)
                    ])
                  ]),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.templates?.results || []), (item) => {
                      return (_openBlock(), _createBlock(_component_MailingMailTemplateOverviewItem, {
                        template: item,
                        pageUI: _ctx.pageUI,
                        key: item.id,
                        onUpdate: _ctx.openDetail,
                        onDelete: _ctx.deleteTemplate
                      }, null, 8, ["template", "pageUI", "onUpdate", "onDelete"]))
                    }), 128)),
                    (!_ctx.templates || !_ctx.templates.results || _ctx.templates.results.length === 0)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_13, [
                          _createElementVNode("td", _hoisted_14, _toDisplayString(_ctx.$t('noResults')), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["pageUI", "submitData"])
      ]),
      _: 1
    }),
    _createVNode(_component_BaseOffcanvas, {
      id: "mailingMailTemplateOffCanvas",
      title: _ctx.$t('mailingTemplate'),
      label: _ctx.$t('mailingTemplate'),
      class: "offcanvas-wide"
    }, {
      default: _withCtx(() => [
        (_openBlock(), _createBlock(_component_MailingMailTemplateDetail, {
          mode: _ctx.detailMode,
          moduleCode: _ctx.module,
          key: _ctx.templateSequence,
          mailingMailTemplateId: _ctx.selectedTemplateId,
          onUpdated: _ctx.reloadContent
        }, null, 8, ["mode", "moduleCode", "mailingMailTemplateId", "onUpdated"]))
      ]),
      _: 1
    }, 8, ["title", "label"])
  ], 64))
}